var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.detailData
    ? _c(
        "div",
        { staticClass: "workpermit-detail" },
        [
          _vm.notStandalone
            ? _c("ProjectInfo", { attrs: { projectPermit: _vm.projectPermit } })
            : _vm._e(),
          _vm._v(" "),
          [
            _c(
              "Collapse",
              {
                staticClass: "workpermit-detail__collapse",
                attrs: {
                  id: _vm.detailData.id,
                  expand: _vm.hoistingsExpandMap[_vm.detailData.id],
                },
                on: { "expand-status": _vm.updateExpandMap },
              },
              [
                _c("CollapseTitleSlot", {
                  key: _vm.detailData.id,
                  attrs: {
                    slot: "title",
                    id: _vm.detailData.id,
                    showDot: _vm.showDotOption(_vm.detailData),
                    permitData: _vm.detailData,
                    dotOption: _vm.dotOption,
                  },
                  slot: "title",
                }),
                _vm._v(" "),
                _c("WPCollapseContent", {
                  staticClass: "workpermit-detail__content",
                  attrs: {
                    slot: "content",
                    permitData: _vm.detailData,
                    isProjectAvailable: _vm.isProjectAvailable,
                  },
                  slot: "content",
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.hoistings, function (item) {
              return !(
                item.status === _vm.WORK_PERMIT_STATUS.DRAFT && _vm.isEngineer
              )
                ? _c(
                    "Collapse",
                    {
                      key: item.id,
                      staticClass: "workpermit-detail__collapse",
                      attrs: {
                        id: item.id,
                        expand:
                          _vm.hoistingsExpandMap[item.id] || !item.createdAt,
                      },
                      on: { "expand-status": _vm.updateExpandMap },
                    },
                    [
                      _c("CollapseTitleSlot", {
                        key: item.id,
                        attrs: {
                          slot: "title",
                          id: item.id,
                          showDot: _vm.showDotOptionForHoisting(item),
                          permitData: item,
                          dotOption: _vm.dotOptionForHoisting(item),
                        },
                        slot: "title",
                      }),
                      _vm._v(" "),
                      _c("HoistingCollapseContent", {
                        staticClass: "workpermit-detail__content",
                        attrs: {
                          slot: "content",
                          permitData: item,
                          floorsOptions: _vm.floorsOptions,
                          isEdit: !item.createdAt,
                          isProjectAvailable: _vm.isProjectAvailable,
                          isPPSuspened: _vm.isPPSuspened,
                          selected: _vm.focusPermitId === item.id,
                        },
                        on: { "expand-status": _vm.updateExpandMap },
                        slot: "content",
                      }),
                    ],
                    1
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _vm.showHoistingModule && _vm.showAddHoistingBtn
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "addNewHoisting",
                      on: { click: _vm._addHoisting },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.addHoistingLabel) + "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "workPermit_hint" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "termsAndConditions." +
                              _vm.regionName +
                              ".workPermit.hintForEdinburghTower",
                            [_vm.hoistingLabel, 5]
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "workPermit_hint" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "termsAndConditions." +
                              _vm.regionName +
                              ".workPermit.hintForOthers",
                            [_vm.hoistingLabel, 3]
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "workPermit_hint" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "termsAndConditions." +
                              _vm.regionName +
                              ".workPermit.hintForPermitNumberLimit",
                            [
                              _vm.maxWAPPRHoistingNum,
                              _vm.standalone
                                ? _vm.$t(
                                    "workPermit.HoistingLimitHintType.work"
                                  )
                                : _vm.$t(
                                    "workPermit.HoistingLimitHintType.project"
                                  ),
                              _vm.hoistingLabel,
                            ]
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          _vm._v(" "),
          _c("ActionConfirmModal", {
            ref: "deleteHoistingModal",
            attrs: {
              modalId: "delete-hoisting-" + +new Date(),
              confirmTitle: _vm.hoistingDeleteConfirmHint,
            },
          }),
          _vm._v(" "),
          _c("ActionConfirmModal", {
            ref: "noShowHoistingModal",
            attrs: {
              modalId: "noShow-hoisting-" + +new Date(),
              confirmTitle: _vm.hoistingNoShowHint,
            },
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }